(function (window, $) {
  const sliders = {
    init: function () {
      const _this = this;

      return new Promise((resolve) => {
        this.initGallery();
        this.initTextLinksSlider();
        this.initTimelineSlider();

        resolve();
      });
    },

    initGallery: function () {
      $(".gallery__slider").slick({
        slidesToShow: 5,
        swipeToSlide: true,
        centerMode: true,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    },

    initTextLinksSlider: function () {
      $(".text-links-slider__slider").each(function () {
        const _this = $(this);

        $(this).slick({
          swipeToSlide: true,
          dots: false,
          infinite: false,
          variableWidth: true,
          prevArrow: _this.next().find(".slick__arrow--prev"),
          nextArrow: _this.next().find(".slick__arrow--next"),
        });
      });
    },

    initTimelineSlider: function () {
      for (const slider of document.querySelectorAll(
        ".timeline-slider__slider"
      )) {
        const sliderEl = slider.querySelector(".timeline-slider__content");
        const timelineEl = slider.querySelector(".timeline-slider__timeline");

        const timelineParams = {
          slidesPerView: 2,
          simulateTouch: false,
          breakpoints: {
            992: {
              slidesPerView: 4,
            },
          },
        };
        const timelineSlider = new Swiper(timelineEl, timelineParams);

        const sliderParams = {
          navigation: {
            nextEl: ".swiper__arrow--next",
            prevEl: ".swiper__arrow--prev",
          },
          pagination: {
            el: ".swiper__pagination",
            type: "fraction",
          },
          simulateTouch: false,
          thumbs: {
            swiper: timelineSlider,
          },
        };
        new Swiper(sliderEl, sliderParams);
      }
    },
  };
  BarbaController.addObject(sliders);
})(window, jQuery);
